import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class TagService extends AbstractService {
	static tagsApi = NexusService.tagsApi;

	static getTags() {
		return this.tagsApi.getTags().then(response => {
			const apiResponse = {
				data: response,
			};

			return apiResponse;
		});
	}

	static updateTag(data) {
		const updateReq = {
			id: data.Id,
			tagUpdatePayload: {
				Name: data.Name,
			},
		};

		return this.tagsApi.updateTag(updateReq).then(response => {
			const apiResponse = {
				data: response,
			};

			return apiResponse;
		});
	}

	static addTag(data) {
		const createTagReq = {
			tagCreatePayload: {
				Name: data.Name,
			},
		};

		return this.tagsApi.createTag(createTagReq).then(response => {
			const apiResponse = {
				data: response,
			};

			return apiResponse;
		});
	}

	static deleteTag(data) {
		return this.tagsApi.deleteTag({ id: data.Id });
	}
}
